module.exports = __webpack_public_path__ + "static/media/2_9.735d4a20.png";